import '@vebox/etui-system';
import { createElement } from 'react';
import { b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import '@vebox/etui-system-elements';
import Label from '../Label/Label.js';

const ToggleLabel = ({
  placement,
  htmlFor,
  children,
  theme
}) => {
  if (!children) {
    return null;
  }
  return /*#__PURE__*/createElement(Label, _extends({}, placement === 'right' ? {
    ml: `${theme.spacing.sm}px`
  } : {
    mr: `${theme.spacing.sm}px`
  }, {
    htmlFor: htmlFor
  }), children);
};

export default ToggleLabel;
